import dynamic from 'next/dynamic';

const DebugFontSize = dynamic(() => import('./DebugFontSize'));

export default DebugFontSize
